import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
import util from "@/mixins/util";
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            liveFiles: [],
            listFiles:[],

            title: '',
            liveTime: [],
            liveStartTime: '',
            liveEndTime: '',
            koin: 0,
            display: '',

            liveOn: false,
            url: '',
            // imageFile: [],
            // content: '',
            // sequence: '',

            // premium: '',
            // videoFile: [],
            // subTitle:'',
            // bookFile:[],
            // bookList: [],
        }
    },
    validators: {
        liveFiles: function (value) {
            return Validator.value(value)
                .required('이미지를 선택해주세요.')
        },
        listFiles: function (value) {
            return Validator.value(value)
                .required('이미지를 선택해주세요.')
        },
        title: function (value) {
            return Validator.value(value)
                .required('제목을 입력해 주세요.')
        },
        liveTime: function (value) {
            return Validator.value(value)
                .required('라이브 예정 시간을 입력해주세요.')
        },
        liveStartTime: function (value) {
            const dateObj = new Date(value);

            return Validator.value(value)
              .custom(() => {
                  if (util.isEmpty(value)) {
                      return '라이브 예정 시간을 입력해주세요.'
                  } else if (dateObj.getUTCMinutes() % 10 !== 0) {
                      return '10분 단위로 입력해주세요.'
                  }
              })
        },
        liveEndTime: function (value) {
            return Validator.value(value)
              .required('라이브 종료 시간을 입력해주세요.')
        },
        url: function (value) {
            return Validator.value(value)
              .custom(() => {
                  if (util.isEmpty(value)) {
                      return '링크를 입력해주세요.'
                  } else if (!util.form.VTypes.url(value)) {
                      return '올바른 주소를 입력해 주세요'
                  }
              })
        },
        koin: function (value) {
            return Validator.value(value)
              .required('KOIN을 입력해 주세요.')
        },
        display: function (value) {
            return Validator.value(value)
              .required('노출 / 미노출 여부를 입력해 주세요.')
        },
        // content: function (value) {
        //     return Validator.value(value)
        //         .required('내용을 입력해주세요.')
        // },
        // sequence: function (value) {
        //     return Validator.value(value)
        //         .integer('1이상의 숫자만 입력이 가능합니다.')
        //         .greaterThanOrEqualTo(1, '1이상의 숫자만 입력이 가능합니다.')
        // },

        // premium: function (value) {
        //     return Validator.value(value)
        //         .required('프리미엄 여부를 설정해주세요.')
        // },
        // videoFile: function (value) {
        //     return Validator.value(value)
        //         .required('이미지를 선택해주세요.')
        // },
        // subTitle: function (value) {
        //     return Validator.value(value)
        // },
    },
}
